var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C11.875 3.87502 11.7054 3.80481 11.5287 3.80481C11.3519 3.80481 11.1824 3.87502 11.0573 4L8 7.05733L4.94267 4C4.81765 3.87502 4.64811 3.80481 4.47133 3.80481C4.29456 3.80481 4.12502 3.87502 4 4C3.87502 4.12502 3.80481 4.29456 3.80481 4.47133C3.80481 4.64811 3.87502 4.81765 4 4.94267L7.05733 8L4 11.0573C3.87502 11.1824 3.80481 11.3519 3.80481 11.5287C3.80481 11.7054 3.87502 11.875 4 12C4.12502 12.125 4.29456 12.1952 4.47133 12.1952C4.64811 12.1952 4.81765 12.125 4.94267 12L8 8.94267L11.0573 12C11.1824 12.125 11.3519 12.1952 11.5287 12.1952C11.7054 12.1952 11.875 12.125 12 12C12.125 11.875 12.1952 11.7054 12.1952 11.5287C12.1952 11.3519 12.125 11.1824 12 11.0573L8.94267 8L12 4.94267C12.125 4.81765 12.1952 4.64811 12.1952 4.47133C12.1952 4.29456 12.125 4.12502 12 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.38c93085f00b4884136f33637d3af27b.svg";
export { ForwardRef as ReactComponent };